// extracted by mini-css-extract-plugin
export default {"maca":"LogosDeTerceiros_maca__DOASC","pix":"LogosDeTerceiros_pix__87oHL"};